import { BookmarkButton, DataTable, SearchInput } from "@/components"

export default {

  data() {
    return {
      loading: false,
      title: "",
    }
  },

  components: {
    BookmarkButton,
    DataTable,
    SearchInput,
  },

  methods: {

    search(search) {              
      
      if (this.$refs.filterModal) {
        this.$refs.filterModal.clear()
        this.clearFilter(search)
      } else {
        this.$refs.dtbl.load(search)
      } 
    },

    refresh() {
      this.$refs.dtbl.refresh()
    },

    filter(data) {              

      if (this.$refs.searchInput)
        this.$refs.searchInput.clear()
        
      this.$refs.dtbl.filter(data)
    },

    clearFilter(search) {
      this.$refs.dtbl.clearFilter(search)
    },
  },
}